/* AXION DEV — Grey Camouflage override remains disabled.
   This asset is intentionally used only for 3D camera motion so it cannot
   alter shell/control materials. */
(()=>{
  const ROOT='[data-axion-configurator][data-product-handle="axion-designer-ps5"]';

  const POSES={
    front:{orbit:'0deg 90deg auto',fov:'22.95deg',target:'center'},
    back:{orbit:'180deg 90deg auto',fov:'22.95deg',target:'center'},
    rearZoom:{orbit:'180deg 86deg auto',fov:'22.95deg',target:'center'},
    rear:{orbit:'180deg 80deg auto',fov:'24deg',target:'rear'},
    upperFront:{orbit:'0deg 72deg auto',fov:'24deg',target:'upper'},
    upperBack:{orbit:'180deg 72deg auto',fov:'24deg',target:'upper'},
    smartBumpers:{orbit:'0deg 66deg auto',fov:'22deg',target:'shoulders'},
    smartTriggers:{orbit:'180deg 66deg auto',fov:'22deg',target:'shoulders'},
    smartFull:{orbit:'150deg 60deg auto',fov:'24deg',target:'shouldersAll'},
    lowerFront:{orbit:'0deg 90deg auto',fov:'20.25deg',target:'center'},
    shell:{orbit:'0deg 90deg auto',fov:'22.95deg',target:'center'},
    personal:{orbit:'0deg 90deg auto',fov:'22.95deg',target:'center'},
    personalTriggers:{orbit:'180deg 90deg auto',fov:'22.95deg',target:'center'},
    review:{orbit:'0deg 90deg auto',fov:'22.95deg',target:'center'},
    face:{orbit:'-6deg 80deg auto',fov:'22deg',target:'face'},
    dpad:{orbit:'6deg 80deg auto',fov:'22deg',target:'dpad'},
    touch:{orbit:'0deg 72deg auto',fov:'22deg',target:'touch'},
    sticks:{orbit:'0deg 78deg auto',fov:'22deg',target:'sticks'}
  };

  document.querySelectorAll(ROOT).forEach(root=>{
    if(root.dataset.axionCameraMotion==='1')return;
    root.dataset.axionCameraMotion='1';
    const v=root.querySelector('[data-axion-model-viewer]');
    if(!v)return;

    // Keep normal rotate + zoom, but block modifier-drag panning/focus
    // so the model-viewer viewport rectangle never gets exposed.
    v.setAttribute('disable-pan','');
    v.style.outline='none';
    v.style.border='0';
    v.style.boxShadow='none';
    const blockModifierPan=e=>{
      if(!(e.shiftKey||e.ctrlKey||e.metaKey))return;
      e.preventDefault();
      e.stopImmediatePropagation();
    };
    ['pointerdown','pointermove','mousedown','mousemove'].forEach(type=>{
      v.addEventListener(type,blockModifierPan,{capture:true,passive:false});
    });

    // <model-viewer> keeps its interactive surface inside an open Shadow DOM.
    // Kill only its internal focus frame; camera controls and geometry stay untouched.
    let frameObserver=null;
    const clearViewerFocus=()=>{
      const sr=v.shadowRoot;
      const active=sr?.activeElement;
      if(active&&typeof active.blur==='function')active.blur();
      if(document.activeElement===v&&typeof v.blur==='function')v.blur();
    };
    const killViewerFrame=()=>{
      v.style.outline='none';
      v.style.border='0';
      v.style.boxShadow='none';

      const sr=v.shadowRoot;
      if(!sr)return;

      if(!sr.querySelector('[data-axion-frame-kill]')){
        const style=document.createElement('style');
        style.dataset.axionFrameKill='1';
        style.textContent=`
          :host,
          :host(:focus),
          :host(:focus-visible),
          #container,
          #container:focus,
          #container:focus-visible,
          .userInput,
          .userInput:focus,
          .userInput:focus-visible,
          canvas,
          canvas:focus,
          canvas:focus-visible,
          [tabindex]:focus,
          [tabindex]:focus-visible {
            outline:none!important;
            border-color:transparent!important;
            box-shadow:none!important;
          }
        `;
        sr.appendChild(style);
      }

      sr.querySelectorAll('#container,.userInput,canvas,[tabindex]').forEach(el=>{
        el.style.outline='none';
        el.style.boxShadow='none';
      });

      if(!frameObserver){
        frameObserver=new MutationObserver(killViewerFrame);
        frameObserver.observe(sr,{childList:true,subtree:true});
      }
    };

    customElements.whenDefined('model-viewer').then(()=>{
      killViewerFrame();
      requestAnimationFrame(killViewerFrame);
    });

    ['pointerdown','pointerup','pointercancel','mouseup','touchend'].forEach(type=>{
      v.addEventListener(type,()=>{
        requestAnimationFrame(()=>{
          killViewerFrame();
          clearViewerFocus();
        });
      },{capture:true});
    });

    // One-shot rotate hint: after the 3D model is ready, wait 3s,
    // show it for 1.5s, then disable it. No tracking and no persistence.
    let rotateHintStarted=false;
    let rotateHintShowTimer=0;
    let rotateHintHideTimer=0;
    const disableRotateHint=()=>v.setAttribute('interaction-prompt','none');
    const startRotateHint=()=>{
      if(rotateHintStarted)return;
      rotateHintStarted=true;
      disableRotateHint();
      rotateHintShowTimer=setTimeout(()=>{
        v.setAttribute('interaction-prompt-threshold','0');
        v.setAttribute('interaction-prompt','auto');
        rotateHintHideTimer=setTimeout(disableRotateHint,1500);
      },3000);
    };
    disableRotateHint();

    v.setAttribute('interpolation-decay','100');

    let raf=0;
    let reviewRaf=0;
    let reviewSpinToken=0;

    const cancelReviewSpin=()=>{
      reviewSpinToken+=1;
      if(reviewRaf)cancelAnimationFrame(reviewRaf);
      reviewRaf=0;
    };

    // Anchor the model once to its true geometric centre. Every configurator
    // transition reuses this exact target, so feature changes cannot translate
    // the controller inside the viewport.
    let lockedTarget='';
    const fixedTarget=()=>{
      if(lockedTarget)return lockedTarget;
      try{
        const c=v.getBoundingBoxCenter?.();
        if(c&&[c.x,c.y,c.z].every(Number.isFinite)){
          lockedTarget=`${c.x}m ${c.y}m ${c.z}m`;
        }
      }catch(_){}
      return lockedTarget||'auto auto auto';
    };

    // Keep whatever zoom/radius the customer currently has. The presets now
    // change theta + phi only: the camera orbits around the stationary pad.
    const currentRadius=()=>{
      try{
        const r=v.getCameraOrbit?.()?.radius;
        return Number.isFinite(r)&&r>0?r:null;
      }catch(_){return null}
    };

    const orbitAtSameDistance=pose=>{
      const parts=pose.orbit.trim().split(/\s+/);
      const theta=parts[0]||'0deg';
      const phi=parts[1]||'78deg';
      const radius=currentRadius();
      return `${theta} ${phi} ${radius?`${radius}m`:'auto'}`;
    };

    const apply=name=>{
      const p=POSES[name]||POSES.front;
      const orbit=orbitAtSameDistance(p);
      v.setAttribute('camera-target',fixedTarget());
      v.setAttribute(
        'field-of-view',
        name==='lowerFront'
          ?'20.25deg'
          :['front','back','rearZoom','smartBumpers','smartTriggers','smartFull','shell','personal','personalTriggers','review'].includes(name)
            ?'22.95deg'
            :'27deg'
      );
      v.setAttribute('camera-orbit',orbit);
      root.dataset.axionCameraPose=name;
    };

    // Review gets one isolated showcase orbit. It never changes the global
    // interpolation setting used by the rest of the configurator.
    const reviewSpin=()=>{
      cancelReviewSpin();
      if(raf)cancelAnimationFrame(raf);
      raf=0;

      const token=reviewSpinToken;
      const radius=currentRadius();
      const radiusText=radius?`${radius}m`:'auto';
      const duration=2600;
      const baseFov=22.95;
      const maxFov=25.25;
      const startedAt=performance.now();
      const ease=t=>t<0.5
        ?4*t*t*t
        :1-Math.pow(-2*t+2,3)/2;

      v.setAttribute('camera-target',fixedTarget());
      v.setAttribute('field-of-view',`${baseFov}deg`);
      v.setAttribute('camera-orbit',`0deg 90deg ${radiusText}`);
      v.jumpCameraToGoal?.();
      root.dataset.axionCameraPose='reviewSpin';

      const frame=now=>{
        if(token!==reviewSpinToken)return;
        const t=Math.min(1,(now-startedAt)/duration);
        const theta=360*ease(t);
        const fov=baseFov+(maxFov-baseFov)*ease(t);
        v.setAttribute('field-of-view',`${fov}deg`);
        v.setAttribute('camera-orbit',`${theta}deg 90deg ${radiusText}`);
        v.jumpCameraToGoal?.();

        if(t<1){
          reviewRaf=requestAnimationFrame(frame);
          return;
        }

        reviewRaf=0;
        v.setAttribute('field-of-view',`${maxFov}deg`);
        v.setAttribute('camera-orbit',`0deg 90deg ${radiusText}`);
        v.jumpCameraToGoal?.();
        root.dataset.axionCameraPose='review';
      };

      reviewRaf=requestAnimationFrame(frame);
    };

    const later=name=>{
      cancelReviewSpin();
      if(raf)cancelAnimationFrame(raf);
      raf=requestAnimationFrame(()=>requestAnimationFrame(()=>{
        raf=0;
        apply(name);
      }));
    };

    const activeStep=()=>{
      const b=root.querySelector('[data-action="step"].is-active');
      return Number(b?.dataset.step||0);
    };

    const smartFaceActive=()=>
      root.querySelector('[data-action="set"][data-key="smartFace"].is-selected')?.dataset.value==='Smart D-Pad & Face Buttons';

    const btPose=value=>{
      if(value==='Smart Triggers L2–R2')return 'smartTriggers';
      if(value==='Smart Bumpers & Triggers')return 'smartFull';
      return 'smartBumpers';
    };

    const currentBtPose=()=>btPose(
      root.querySelector('[data-action="set"][data-key="btType"].is-selected')?.dataset.value
    );

    const rearCountValue=()=>
      root.querySelector('[data-action="set"][data-key="rearCount"].is-selected')?.dataset.value||'0';
    const rearPose=value=>(value==='2'||value==='4')?'rearZoom':'back';

    const poseForStep=i=>{
      if(i===0)return rearPose(rearCountValue());
      if(i===1)return smartFaceActive()?'front':currentBtPose();
      if(i===2)return 'lowerFront';
      if(i===3)return 'shell';
      if(i===4)return 'personal';
      if(i===6)return 'review';
      return 'front';
    };

    const goStep=i=>{
      if(i===6){
        reviewSpin();
        return;
      }
      later(poseForStep(i));
    };
    root.__axionSetCameraForStep=goStep;

    const aestheticPose=key=>{
      if(key==='face')return 'face';
      if(key==='dpad')return 'dpad';
      if(key==='touch'||key==='share')return 'touch';
      if(key==='sticks'||key==='rings'||key==='ps'||key==='mic')return 'sticks';
      if(key==='triggers')return 'upperBack';
      if(key==='bumpers')return 'upperFront';
      return 'personal';
    };

    root.addEventListener('click',e=>{
      const b=e.target.closest('button');
      if(!b||b.disabled)return;
      const a=b.dataset.action,k=b.dataset.key;

      if(a==='view'){
        later(b.dataset.view==='back'?'back':'front');
        return;
      }
      if(a==='set'&&k==='rearCount'){later(rearPose(b.dataset.value));return}
      if(a==='set'&&k==='btType'){later(btPose(b.dataset.value));return}
      if(a==='set'&&k==='smartFace'){
        later(b.dataset.value==='Smart D-Pad & Face Buttons'?'front':currentBtPose());
        return;
      }
      if(a==='tmr'){later('lowerFront');return}
      if(a==='shell'){later('shell');return}
      if(a==='rear-color'){later(rearPose(rearCountValue()));return}
      if(a==='set'&&k==='aestheticMode'){
        later('personal');
        return;
      }
      if(a==='a-mode'){
        later(k==='triggers'?'personalTriggers':'personal');
        return;
      }
    });

    root.addEventListener('change',e=>{
      const el=e.target.closest('[data-action="select"]');
      const k=el?.dataset.key||'';
      if(k.startsWith('rearPosition')||k.startsWith('map'))later(rearPose(rearCountValue()));
    });

    const initial=()=>{
      const tab=root.querySelector('[data-view].is-active');
      later(tab?.dataset.view==='front'?'front':'back');
    };

    v.addEventListener('load',()=>{
      killViewerFrame();
      startRotateHint();
      initial();
    });
    if(v.model){
      killViewerFrame();
      startRotateHint();
      initial();
    }

    window.addEventListener('pagehide',()=>{
      if(rotateHintShowTimer)clearTimeout(rotateHintShowTimer);
      if(rotateHintHideTimer)clearTimeout(rotateHintHideTimer);
      if(reviewRaf)cancelAnimationFrame(reviewRaf);
      if(frameObserver)frameObserver.disconnect();
    },{once:true});
  });
})();
